// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportTitleSkeleton_container__2Typn","header":"ReportTitleSkeleton_header__1GHKd","btns":"ReportTitleSkeleton_btns__Ybers"};